module.exports = __webpack_public_path__ + "img/グループ 257.eb96729f.png";